import React from "react";
import { useState } from "react";
import http from "../../../http";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import ReactDatePicker from "react-datepicker";
import { productLang } from "../../../Components/language/pages/productLang";
import useLanguage from "../../../Components/language/useLanguage";
import CKEditorWrapper from "../../../Components/CKEditorWrapper";

function EditDrugs() {
  const lan = useLanguage(productLang);
  const navigate = useNavigate();
  const { id } = useParams();
  const [errors, setError] = useState([]);
  // const [picture, setPicture] = useState([]);
  const [picture, setPicture] = useState();

  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [brand, setBrand] = useState([]);
  const [group, setGroup] = useState([]);
  const [mrpChannelList, setMrpChannelList] = useState([]);
  const [form_data, setFormData] = useState({
    src_primary_key: "",
    generic_id: "",
    usual_provider_id: "",
    drug_description: "",
    strength: "",
    macrohealth_sg: "",
    mims_sg: "",
    mims_type: "",
    guid: "",
    drug_name: "",
    qty: "",
    rpts: "",
    box_size: 1,
    tgp: "",
    restriction: "",
    brand_id: "",
    group_id: "",
    category_id: "",
    sub_category_id: "",
    stock: "",
    drug_code: "",
    class: "",
    batch: "",
    expiry_date: new Date(),
    price: "",
    drug_price: "",
    offer_price: "",
    generic_Name: "",
    boxType: "",
    pktSize: "",
    unit: "",
    drug_discount: "",
    cash_drug_discount: "",
    card_drug_discount: "",
    digital_drug_discount: "",
    drug_weight: "",
    main_image: "",
    summary: "",
    condition: "",
    status: "",
    is_stockable: 1,
  });

  // MRP price by channel: [{ channel_name, mrp_price }]
  const [mrpPrices, setMrpPrices] = useState([
    { channel_name: "", mrp_price: "" },
  ]);

  const toStr = (v) => (v === null || v === undefined ? "" : String(v));

  // Normalize API response -> form shape (prevents empty fields on edit)
  const normalizeDrugForForm = (raw) => {
    const data = raw || {};

    // Handle expiry_date - convert string to Date object if needed
    let expiryDate = data.expiry_date;
    if (expiryDate) {
      if (typeof expiryDate === 'string') {
        expiryDate = new Date(expiryDate);
      } else if (!(expiryDate instanceof Date)) {
        expiryDate = new Date();
      }
    } else {
      expiryDate = new Date();
    }

    const normalized = {
      // Text inputs: never allow null/undefined (prevents controlled/uncontrolled warnings)
      src_primary_key: toStr(data.src_primary_key),
      generic_id: toStr(data.generic_id),
      usual_provider_id: toStr(data.usual_provider_id),
      strength: toStr(data.strength),
      macrohealth_sg: toStr(data.macrohealth_sg),
      drug_code: toStr(data.drug_code),
      batch: toStr(data.batch),
      drug_description: data.drug_description || "",
      drug_name: toStr(data.drug_name),
      qty: toStr(data.qty),
      rpts: toStr(data.rpts),
      tgp: toStr(data.tgp),
      restriction: toStr(data.restriction),
      stock: toStr(data.stock),
      class: toStr(data.class),
      offer_price: toStr(data.offer_price),
      generic_Name: toStr(data.generic_Name),
      drug_discount: toStr(data.drug_discount),
      cash_drug_discount: toStr(data.cash_drug_discount),
      card_drug_discount: toStr(data.card_drug_discount),
      digital_drug_discount: toStr(data.digital_drug_discount),
      drug_weight: toStr(data.drug_weight),
      summary: toStr(data.summary),
      condition: toStr(data.condition),
      mims_sg: toStr(data.mims_sg),
      mims_type: toStr(data.mims_type),
      guid: toStr(data.guid),
      // IDs/select values: keep as strings for controlled <select>
      brand_id: toStr(data.brand_id),
      group_id: toStr(data.group_id),
      category_id: toStr(data.category_id),
      sub_category_id: toStr(data.sub_category_id),

      // Price fields: some environments may not have `price` column
      drug_price: toStr(data.drug_price ?? data.price),
      price: toStr(data.price ?? data.drug_price),

      // Image fields: backend uses main_image, list view sometimes uses image
      main_image: toStr(data.main_image ?? data.image),
      image: toStr(data.image ?? data.main_image),

      // Optional fields (may not exist in some DB schemas)
      unit: toStr(data.unit),
      boxType: toStr(data.boxType ?? data.box_type),
      pktSize: toStr(data.pktSize ?? data.pkt_size),
      is_stockable: toStr(data.is_stockable ?? 1),
      status: toStr(data.status),
      
      // Date field
      expiry_date: expiryDate,
      
      // Keep box_size as number
      box_size: data.box_size ?? 1,
    };

    return normalized;
  };

  useEffect(() => {
    if (!id) {
      console.error("EditDrugs: No ID provided");
      return;
    }

    http.get(`drugs/${id}/edit`).then((res) => {
      console.log("EditDrugs API Response:", res.data);
      if (res.data.status === 200) {
        const normalized = normalizeDrugForForm(res.data.data);
        console.log("Normalized data:", normalized);
        // Merge into defaults so missing keys don't wipe the form
        setFormData((prev) => {
          const merged = { ...prev, ...normalized };
          console.log("Merged form data:", merged);
          return merged;
        });

        // If drug doesn't store group_id, infer it from category list
        if (!normalized.group_id && normalized.category_id) {
          http.get(`/category`).then((catRes) => {
            const all = catRes?.data?.data || [];
            const current = all.find(
              (c) => String(c.id) === String(normalized.category_id)
            );
            if (current?.group_id) {
              setFormData((prev) => ({
                ...prev,
                group_id: String(current.group_id),
              }));
            }
          });
        }

        if (res.data.academic && res.data.academic.length > 0) {
          setAcademicArray(res.data.academic);
          setscan_copy_Academic(res.data.academic);
          // Initialize preview URLs for existing images
          const initialUrls = res.data.academic.map((item) => {
            if (item.scan_copy) {
              const baseImageUrl = process.env.REACT_APP_DEV_MODE_IMAGE_URL || 
                                  process.env.REACT_APP_IMAGE_URL || 
                                  process.env.REACT_APP_PRO_MODE_IMAGE_URL || 
                                  'http://127.0.0.1:8001';
              const cleanBaseUrl = baseImageUrl.replace(/\/$/, '');
              const imageFileName = item.scan_copy.replace(/^.*[\\\/]/, '');
              return `${cleanBaseUrl}/files/drugs/${imageFileName}`;
            }
            return null;
          });
          setMultipleImageUrls(initialUrls);
        } else {
          setMultipleImageUrls([null]);
        }

        // Load channel MRP prices
        if (res.data.mrp_prices && Array.isArray(res.data.mrp_prices) && res.data.mrp_prices.length > 0) {
          setMrpPrices(
            res.data.mrp_prices.map((row) => ({
              channel_name: row.channel_name || "",
              mrp_price: row.mrp_price != null ? String(row.mrp_price) : "",
            }))
          );
        } else {
          setMrpPrices([{ channel_name: "", mrp_price: "" }]);
        }
      } else {
        console.error("EditDrugs API Error:", res.data);
        setError(res.data.errors);
      }
    }).catch((error) => {
      console.error("EditDrugs API Request Failed:", error);
      Swal.fire({
        position: "top-center",
        icon: "error",
        title: "Failed to load product data",
        text: error.message || "Please try again",
        timer: 2500,
      });
    });
    http.get("brand").then((res) => {
      setBrand(res.data.data);
    });
    // http.get('category').then((res) => {
    //   setCategory(res.data.data);
    // });
    // http.get('subcategory').then((res) => {
    //   setSubCategory(res.data.data);
    // });
    http.get(`/group`).then((res) => {
      if (res.status === 200) {
        setGroup(res.data.data);
      }
    });
    http.get("mrp-master-channels").then((res) => {
      if (res.data?.status === 200 && Array.isArray(res.data.data)) {
        setMrpChannelList(res.data.data);
      }
    }).catch(() => setMrpChannelList([]));
  }, [id]);
  useEffect(() => {
    if (form_data?.group_id) {
      http.get(`category-by-group/${form_data?.group_id}`).then((res) => {
        setCategory(res.data.data);
      });
    }
    if (form_data?.category_id) {
      http
        .get(`sub-category-by-category/${form_data?.category_id}`)
        .then((res) => {
          setSubCategory(res.data.data);
        });
    }
  }, [form_data?.group_id, form_data?.category_id]);

  // Cleanup function to revoke object URLs when component unmounts
  useEffect(() => {
    return () => {
      // Revoke all multiple image URLs
      multipleImageUrls.forEach((url) => {
        if (url) {
          URL.revokeObjectURL(url);
        }
      });
      // Revoke main image URL
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleInput = (e) => {
    if (e.target.name === "brand_id") {
      setFormData((prev) => ({
        ...prev,
        brand_id: e.target.value,
        manufacturer: brand.find(
          (x) => parseInt(x.id) === parseInt(e.target.value)
        )?.title,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };
  const [docImage_error, setdocImage_error] = useState();
  const [image_error, setimage_error] = useState();
  const [imageUrl, setimageUrl] = useState();

  const handleimageUrl = (event) => {
    if (event.target.files[0].size < 2000048) {
      setPicture(event.target.files[0]);
      setimage_error(null);
    } else {
      setimage_error(lan?.img);
    }
    if (
      event.target.files &&
      event.target.files[0] &&
      event.target.files[0].size < 2000048
    ) {
      setimageUrl(URL.createObjectURL(event.target.files[0]));
    } else {
      setimage_error(lan?.img);
    }
  };
  const closeImage = () => {
    // Revoke the object URL to free memory
    if (imageUrl) {
      URL.revokeObjectURL(imageUrl);
    }
    setimageUrl(null);
    document.getElementById("imageUrl").value = "";
    setPicture(null);
  };

  const handleMrpPricesChange = (index, field, value) => {
    const list = [...mrpPrices];
    list[index] = { ...list[index], [field]: value };
    setMrpPrices(list);
  };
  const handleAddMrpRow = () => {
    setMrpPrices([...mrpPrices, { channel_name: "", mrp_price: "" }]);
  };
  const handleRemoveMrpRow = (index) => {
    if (mrpPrices.length <= 1) return;
    const list = [...mrpPrices];
    list.splice(index, 1);
    setMrpPrices(list);
  };

  const [AcademicArray, setAcademicArray] = useState([
    {
      id: "",
      drugs_master_id: "",
      // scan_copy_title: ''
    },
  ]);

  const [scan_copy_Academic, setscan_copy_Academic] = useState([
    { scan_copy: "" },
  ]);

  // State for multiple image preview URLs
  const [multipleImageUrls, setMultipleImageUrls] = useState([null]);

  const handleChangeAcademic = (e, index) => {
    const { name, value } = e.target;
    const list = [...AcademicArray];
    list[index][name] = value;
    setAcademicArray(list);
  };
  const handle_Academic_File = (e, index) => {
    if (e.target.files && e.target.files[0]) {
      if (e.target.files[0].size < 2000048) {
        const { name } = e.target;

        const fileList = [...scan_copy_Academic];
        fileList[index][name] = e.target.files[0];
        setscan_copy_Academic(fileList);

        // Create preview URL for the image
        const previewUrl = URL.createObjectURL(e.target.files[0]);
        const urlList = [...multipleImageUrls];
        urlList[index] = previewUrl;
        setMultipleImageUrls(urlList);

        setdocImage_error(null);
      } else {
        setdocImage_error(lan?.img);
      }
    }
  };
  const handleAddInput = () => {
    setAcademicArray([
      ...AcademicArray,
      {
        id: "",
        // scan_copy_title: '',
        scan_copy: [],
      },
    ]);

    setscan_copy_Academic([
      ...scan_copy_Academic,
      {
        scan_copy: "",
      },
    ]);

    // Add null for new preview URL
    setMultipleImageUrls([...multipleImageUrls, null]);
  };

  const handleRemoveInput = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Revoke the object URL to free memory
        if (multipleImageUrls[index]) {
          URL.revokeObjectURL(multipleImageUrls[index]);
        }

        const list = [...AcademicArray];
        list.splice(index, 1);
        setAcademicArray(list);

        const listFile = [...scan_copy_Academic];
        listFile.splice(index, 1);
        setscan_copy_Academic(listFile);

        // Remove preview URL
        const urlList = [...multipleImageUrls];
        urlList.splice(index, 1);
        setMultipleImageUrls(urlList);

        if (AcademicArray[index].id !== "") {
          http
            .delete(`/destroy-drugs-images/${AcademicArray[index].id}`)
            .then((res) => {
              console.log("Academic row Detele");
            });
        }

        Swal.fire("Deleted!", "Your data has been deleted.", "success");
      }
    });
  };

  // Function to close/remove individual multiple image preview
  const closeMultipleImage = (index) => {
    // Revoke the object URL to free memory
    if (multipleImageUrls[index]) {
      URL.revokeObjectURL(multipleImageUrls[index]);
    }

    // Clear the preview URL
    const urlList = [...multipleImageUrls];
    urlList[index] = null;
    setMultipleImageUrls(urlList);

    // Clear the file input using the ID
    const fileInput = document.getElementById(`multiple_image_${index}`);
    if (fileInput) {
      fileInput.value = "";
    }

    // Clear the file from state
    const fileList = [...scan_copy_Academic];
    fileList[index].scan_copy = "";
    setscan_copy_Academic(fileList);
  };

  const submitFormData = (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append(
      "src_primary_key",
      form_data.src_primary_key == null ? "" : form_data.src_primary_key
    );
    formData.append(
      "generic_id",
      form_data.generic_id == null ? "" : form_data.generic_id
    );
    formData.append(
      "usual_provider_id",
      form_data.usual_provider_id == null ? "" : form_data.usual_provider_id
    );
    formData.append(
      "drug_description",
      form_data.drug_description == null ? "" : form_data.drug_description
    );
    formData.append(
      "strength",
      form_data.strength == null ? "" : form_data.strength
    );
    formData.append(
      "macrohealth_sg",
      form_data.macrohealth_sg == null ? "" : form_data.macrohealth_sg
    );
    formData.append(
      "mims_sg",
      form_data.mims_sg == null ? "" : form_data.mims_sg
    );
    formData.append(
      "mims_type",
      form_data.mims_type == null ? "" : form_data.mims_type
    );
    formData.append(
      "is_stockable",
      form_data.is_stockable == null ? "" : form_data.is_stockable
    );
    formData.append(
      "drug_name",
      form_data.drug_name == null ? "" : form_data.drug_name
    );
    formData.append(
      "drug_price",
      form_data.drug_price == null ? 0 : form_data.drug_price
    );
    formData.append("qty", form_data.qty == null ? "" : form_data.qty);
    formData.append("rpts", form_data.rpts == null ? "" : form_data.rpts);
    formData.append("box_size", 1);
    formData.append("tgp", form_data.tgp == null ? "" : form_data.tgp);
    formData.append(
      "restriction",
      form_data.restriction == null ? "" : form_data.restriction
    );
    formData.append(
      "brand_id",
      form_data.brand_id == null ? "" : form_data.brand_id
    );
    formData.append(
      "group_id",
      form_data.group_id == null ? "" : form_data.group_id
    );
    formData.append(
      "category_id",
      form_data.category_id == null ? "" : form_data.category_id
    );
    formData.append(
      "sub_category_id",
      form_data.sub_category_id == null ? "" : form_data.sub_category_id
    );
    formData.append("stock", form_data.stock == null ? "" : form_data.stock);
    formData.append(
      "drug_code",
      form_data.drug_code == null ? "" : form_data.drug_code
    );
    formData.append("class", form_data.class == null ? "" : form_data.class);
    formData.append("batch", form_data.batch == null ? "" : form_data.batch);
    formData.append(
      "expiry_date",
      form_data.expiry_date == null ? "" : form_data.expiry_date
    );
    formData.append("price", form_data.price == null ? "" : form_data.price);
    formData.append("mrp_prices", JSON.stringify(mrpPrices));
    formData.append(
      "manufacturer",
      form_data.manufacturer == null ? "" : form_data.manufacturer
    );
    formData.append(
      "generic_Name",
      form_data.generic_Name == null ? "" : form_data.generic_Name
    );

    formData.append(
      "boxType",
      form_data.boxType == null ? "" : form_data.boxType
    );
    formData.append(
      "pktSize",
      form_data.pktSize == null ? "" : form_data.pktSize
    );
    formData.append("unit", form_data.unit == null ? "" : form_data.unit);

    formData.append(
      "drug_discount",
      form_data.drug_discount == null ? "" : form_data.drug_discount
    );
    formData.append(
      "cash_drug_discount",
      form_data.cash_drug_discount == null ? "" : form_data.cash_drug_discount
    );
    formData.append(
      "card_drug_discount",
      form_data.card_drug_discount == null ? "" : form_data.card_drug_discount
    );
    formData.append(
      "digital_drug_discount",
      form_data.digital_drug_discount == null
        ? ""
        : form_data.digital_drug_discount
    );

    formData.append(
      "drug_weight",
      form_data.drug_weight == null ? "" : form_data.drug_weight
    );
    formData.append(
      "summary",
      form_data.summary == null ? "" : form_data.summary
    );
    formData.append(
      "condition",
      form_data.condition == null ? "" : form_data.condition
    );
    formData.append("status", form_data.status == null ? "" : form_data.status);
    // formData.append('main_image', form_data.main_image == null ? '' : form_data.main_image);

    formData.append(
      "main_image",
      picture == null ? form_data.main_image : picture
    );

    http.post(`drugs/update/${id}`, formData).then((res) => {
      if (res.data.status === 200) {
        AcademicArray.map((item, i) => {
          if (scan_copy_Academic[i].scan_copy !== "") {
            const academic = new FormData();
            academic.append("drugs_master_id", res.data.drugs_id);
            // academic.append('scan_copy_title', item.scan_copy_title);
            academic.append("scan_copy", scan_copy_Academic[i].scan_copy);

            if (item.id !== "") {
              http
                .post(`/update-drugs-images/${item.id}`, academic)
                .then((res) => {
                  console.log("save-doctors-academic");
                });
            } else {
              http.post("save-drugs-images", academic).then((res) => {
                console.log("save-doctors-academic");
              });
            }
          }
        });

        Swal.fire({
          position: "top-center",
          icon: "success",
          title: res.data.message,
          timer: 2500,
        });
        navigate("/drugs");
      } else {
        setError(res.data.errors);
      }
    });
  };
  // Debug: Log form_data when it changes
  useEffect(() => {
    console.log("EditDrugs form_data updated:", form_data);
  }, [form_data]);
  return (
    <div className="page-content">
      <div className="custom-card patients-head ">
        <h5 className="fw-normal custom_py-3 px-2  text-start mb-2 card-title">
          {lan?.editProduct}
          <button
            className="btn btn-sm btn-warning float-end"
            onClick={() => navigate(-1)}
          >
            <i className="fal fa-long-arrow-left"></i> {lan?.back}
          </button>
        </h5>
      </div>

      <div className="row new-patient-entry me-1">
        <form className="" onSubmit={submitFormData}>
          {/* Product Basic Information Card */}
          <div className="custom-card mb-2">
            <div className="pt-2 px-4">
              <h6 className="">Product Basic Information</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="drug_code" className="form-label">
                      {lan?.productCode}
                    </label>
                    <input
                      type="text"
                      name="drug_code"
                      disabled
                      className="form-control form-control-sm"
                      value={form_data.drug_code ?? ""}
                      onChange={handleInput}
                    />
                    <span className="text-danger">{errors.drug_code}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="macrohealth_sg" className="form-label">
                      {lan?.productName}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="macrohealth_sg"
                      className="form-control form-control-sm"
                      value={form_data.macrohealth_sg ?? ""}
                      onChange={handleInput}
                    />
                    <span className="text-danger">
                      {errors?.macrohealth_sg}
                    </span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="brand_id" className="form-label">
                      {lan?.brand} <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="brand_id"
                      id="brand_id"
                      value={form_data.brand_id || ""}
                      onChange={handleInput}
                    >
                      <option value="" disabled>
                        {lan?.select}
                      </option>
                      {brand.map((item) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                    <span className="text-danger">{errors.brand_id}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="group_id" className="form-label">
                      {lan?.group}
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="group_id"
                      id="group_id"
                      value={form_data.group_id || ""}
                      onChange={handleInput}
                    >
                      <option value="" disabled>
                        {lan?.select}
                      </option>
                      {group.map((item) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                    <span className="text-danger">{errors.group_id}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="category_id" className="form-label">
                      {lan?.category} <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="category_id"
                      id="category_id"
                      value={form_data.category_id || ""}
                      onChange={handleInput}
                    >
                      <option value="" disabled>
                        {lan?.select}
                      </option>
                      {category.map((item) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                    <span className="text-danger">{errors.category_id}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="sub_category_id" className="form-label">
                      {lan?.subCategory}
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="sub_category_id"
                      id="sub_category_id"
                      value={form_data.sub_category_id || ""}
                      onChange={handleInput}
                    >
                      <option value="" disabled>
                        {lan?.select}
                      </option>
                      {subcategory.map((item) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.title}
                          </option>
                        );
                      })}
                    </select>
                    <span className="text-danger">
                      {errors.sub_category_id}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Product Specification Card */}
          <div className="custom-card mb-2">
            <div className="pt-2 px-4">
              <h6 className="">Product Specification</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="drug_price" className="form-label">
                      {lan?.purchasePrice}
                    </label>
                    <input
                      type="number"
                      name="drug_price"
                      className="form-control form-control-sm"
                      min={0}
                      value={form_data.drug_price ?? ""}
                      onChange={handleInput}
                    />
                    <span className="text-danger">
                      {errors.drug_price ? errors.drug_price : null}
                    </span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="unit" className="form-label">
                      {lan?.unit} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="unit"
                      className="form-control form-control-sm"
                      value={form_data.unit ?? ""}
                      onChange={handleInput}
                    />
                    <span className="text-danger">{errors.unit}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="boxType" className="form-label">
                      {lan?.boxType}
                    </label>
                    <input
                      type="text"
                      name="boxType"
                      className="form-control form-control-sm"
                      value={form_data.boxType ?? ""}
                      onChange={handleInput}
                    />
                    <span className="text-danger">{errors.boxType}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="pktSize" className="form-label">
                      {lan?.packetSize}
                    </label>
                    <input
                      type="text"
                      name="pktSize"
                      className="form-control form-control-sm"
                      value={form_data.pktSize ?? ""}
                      onChange={handleInput}
                    />
                    <span className="text-danger">{errors.pktSize}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="expiry_date" className="form-label">
                      {lan?.expiryDate}
                    </label>
                    <br />
                    <ReactDatePicker
                      className="form-control form-control-sm"
                      selected={
                        form_data?.expiry_date
                          ? (form_data.expiry_date instanceof Date 
                              ? form_data.expiry_date 
                              : new Date(form_data.expiry_date))
                          : new Date()
                      }
                      dateFormat="dd/MM/yyyy"
                      onChange={(date) => {
                        setFormData((prev) => ({
                          ...prev,
                          expiry_date: date,
                        }));
                      }}
                    />
                    <span className="text-danger">{errors.expiry_date}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="batch" className="form-label">
                      {lan?.batch}
                    </label>
                    <input
                      type="text"
                      name="batch"
                      className="form-control form-control-sm"
                      value={form_data.batch ?? ""}
                      onChange={handleInput}
                    />
                    <span className="text-danger">{errors.batch}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="is_stockable" className="form-label">
                      Stock Type
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="is_stockable"
                      id="is_stockable"
                      onChange={handleInput}
                      value={form_data?.is_stockable ?? ""}
                    >
                      <option value="" disabled>
                        {lan?.select}
                      </option>
                      <option value="1">Stock Item</option>
                      <option value="0">Non Stock Item</option>
                    </select>
                    <span className="text-danger">{errors.is_stockable}</span>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-2">
                    <label htmlFor="status" className="form-label">
                      {lan?.status}
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="status"
                      id="status"
                      onChange={handleInput}
                      value={form_data.status || ""}
                    >
                      <option value="" disabled>
                        {lan?.select}
                      </option>
                      <option value="1">{lan?.active}</option>
                      <option value="0">{lan?.inactive}</option>
                    </select>
                    <span className="text-danger">{errors.status}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* MRP Price by Channel Card - separate card under Product Specification */}
          <div className="custom-card mb-2">
            <div className="pt-2 px-4">
              <h6 className="">{lan?.mrpPriceByChannel}</h6>
            </div>
            <div className="card-body">
              {mrpPrices.map((row, i) => {
                const masterNames = (mrpChannelList || []).map((c) => c.channel_name);
                const legacyNames = [...new Set(
                  mrpPrices.map((r) => r.channel_name).filter((n) => n && !masterNames.includes(n))
                )];
                const channelOptions = [
                  ...(mrpChannelList || []).map((c) => ({ id: c.id, channel_name: c.channel_name })),
                  ...legacyNames.map((name) => ({ id: `legacy-${name}`, channel_name: name })),
                ];
                return (
                <div key={i} className="row align-items-end mb-2">
                  <div className="col-md-5">
                    <label className="form-label small">{lan?.channelName}</label>
                    <select
                      className="form-select form-select-sm"
                      value={row.channel_name}
                      onChange={(e) =>
                        handleMrpPricesChange(i, "channel_name", e.target.value)
                      }
                    >
                      <option value="">{lan?.select ?? "Select channel"}</option>
                      {channelOptions.map((ch) => (
                        <option key={ch.id} value={ch.channel_name}>
                          {ch.channel_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small">{lan?.mrpPrice}</label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      min={0}
                      step="0.01"
                      placeholder="0"
                      value={row.mrp_price}
                      onChange={(e) =>
                        handleMrpPricesChange(i, "mrp_price", e.target.value)
                      }
                    />
                  </div>
                  <div className="col-md-3">
                    {mrpPrices.length > 1 ? (
                      <button
                        type="button"
                        className="btn btn-warning btn-sm me-1"
                        onClick={() => handleRemoveMrpRow(i)}
                      >
                        {lan?.remove}
                      </button>
                    ) : null}
                    {i === mrpPrices.length - 1 && (
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={handleAddMrpRow}
                      >
                        + {lan?.addMore}
                      </button>
                    )}
                  </div>
                </div>
                );
              })}
            </div>
          </div>

          {/* Media and Image Card */}
          <div className="custom-card mb-2">
            <div className="pt-2 px-4">
              <h6 className="">Media and Image</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-2">
                    <label htmlFor="main_image" className="form-label">
                      {lan?.mainImage}
                    </label>
                    <input
                      type="file"
                      name="main_image"
                      id="imageUrl"
                      onChange={handleimageUrl}
                      className="form-control form-control-sm"
                      accept="image/jpg,image/jpeg,image/gif,image/png"
                    />
                    {image_error == null ? (
                      <p className="doc_image_size">{lan?.img}</p>
                    ) : (
                      <p className="photo_size_error">{image_error}</p>
                    )}

                    {imageUrl == null ? (
                      (form_data.main_image || form_data.image) ? (
                        <div className="photo_close mt-2">
                          <img
                            src={`${(() => {
                              const baseImageUrl = global.img_url || 
                                                  process.env.REACT_APP_DEV_MODE_IMAGE_URL || 
                                                  process.env.REACT_APP_IMAGE_URL || 
                                                  process.env.REACT_APP_PRO_MODE_IMAGE_URL || 
                                                  'http://127.0.0.1:8001';
                              return baseImageUrl.replace(/\/$/, '');
                            })()}/files/drugs/${(() => {
                              const imageFileName = (form_data.main_image || form_data.image || '').replace(/^.*[\\\/]/, '');
                              return imageFileName.split('?')[0].split('#')[0].trim();
                            })()}`}
                            className="photo_preview_url"
                            width="100"
                            height="100"
                            alt="preview"
                            onError={(e) => {
                              console.error('Failed to load image:', e.target.src);
                              e.target.style.display = 'none';
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      <div className="photo_close mt-2">
                        <img
                          src={imageUrl}
                          className="photo_preview_url"
                          width="100"
                          height="100"
                          alt="preview"
                        />
                        <i
                          onClick={closeImage}
                          className="far fa-times-circle"
                          style={{ cursor: 'pointer' }}
                        ></i>
                      </div>
                    )}
                    <span className="text-danger">{errors.main_image}</span>
                  </div>
                </div>
              </div>
              
              {/* Product Variant Card for Multiple Images */}
              <div className="custom-card mb-2 mt-3" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="pt-2 px-4">
                  <h6 className="mb-0">{lan?.multipleImage}</h6>
                </div>
                <div className="card-body">
                  {AcademicArray.map((item, i) => {
                    return (
                      <div key={i} className="mb-3">
                        <input
                          type="file"
                          name="scan_copy"
                          id={`multiple_image_${i}`}
                          onChange={(e) => handle_Academic_File(e, i)}
                          className="form-control form-control-sm"
                          accept="image/jpg,image/jpeg,image/gif,image/png"
                        />

                        {docImage_error == null ? (
                          <p className="doc_image_size">{lan?.img}</p>
                        ) : (
                          <p className="docimage_error">{docImage_error}</p>
                        )}

                        {/* Preview for multiple images */}
                        {multipleImageUrls[i] == null ? (
                          item.scan_copy && typeof item.scan_copy === 'string' ? (
                            <div className="photo_close mt-2">
                              <img
                                src={`${global.img_url || (process.env.REACT_APP_DEV_MODE_IMAGE_URL || process.env.REACT_APP_IMAGE_URL || process.env.REACT_APP_PRO_MODE_IMAGE_URL || 'http://127.0.0.1:8001').replace(/\/$/, '')}/files/drugs/${item.scan_copy.replace(/^.*[\\\/]/, '')}`}
                                className="photo_preview_url"
                                width="100"
                                height="100"
                                alt={`preview ${i + 1}`}
                              />
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          <div className="photo_close mt-2">
                            <img
                              src={multipleImageUrls[i]}
                              className="photo_preview_url"
                              width="100"
                              height="100"
                              alt={`preview ${i + 1}`}
                            />
                            <i
                              onClick={() => closeMultipleImage(i)}
                              className="far fa-times-circle"
                              style={{ cursor: 'pointer' }}
                            ></i>
                          </div>
                        )}

                        <div className="mt-2">
                          {AcademicArray.length - 1 === i && (
                            <input
                              type="button"
                              onClick={handleAddInput}
                              className="btn btn-success btn-sm"
                              value={`+ ${lan?.addMore}`}
                            />
                          )}
                          {AcademicArray.length !== 1 && (
                            <input
                              type="button"
                              onClick={() => handleRemoveInput(i)}
                              className="btn btn-warning btn-sm ms-2"
                              value={`- ${lan?.remove}`}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Product Description Card */}
          <div className="custom-card mb-2">
            <div className="pt-2 px-4">
              <h6 className="">Product Description</h6>
            </div>
            <div className="card-body">
              <div className="mb-2">
                <label htmlFor="drug_description" className="form-label">
                  {lan?.description}
                </label>
                <CKEditorWrapper
                  value={form_data.drug_description}
                  onChange={(data) => {
                    setFormData((prev) => ({
                      ...prev,
                      drug_description: data,
                    }));
                  }}
                />
                <span className="text-danger">
                  {errors.drug_description}
                </span>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="mb-3">
            <button
              type="submit"
              className="btn btn-success btn-sm text-uppercase float-end"
            >
              <i className="fas fa-save"></i> {lan?.update}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditDrugs;
